import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import PlaceIcon from "@mui/icons-material/Place";
import WorkIcon from '@mui/icons-material/Work';


function TabsHeader({ activoCv, activoBuy, activoContact, titulo }) {
  return (

        <>
          <Box className="tabs-contact" >
            <Tabs aria-label="icon label tabs"
             >
              <Tab
                value="contacto"
                href="/contacto"
                aria-labelledby="contacto"
                aria-label="contacto"
                className={`icon-tab ${activoContact && "active"}`}
                icon={<MailIcon titleAccess="Contacto" aria-label="Sección Contacto" />}
              />
              <Tab
              value="carga-cv"
                href="/trabajar-con-nosotros"
                aria-label="carga-cv"
                className={`icon-tab ${activoCv && "active"} red`}
                icon={<WorkIcon titleAccess="Trabaja con Nosotros" aria-label="Trabaja con Nosotros" />}
              />
              <Tab
              value="donde-comprar"
                href="/donde-comprar"
                aria-label="donde-comprar"
                className={`icon-tab ${activoBuy && "active"}`}
                icon={<PlaceIcon titleAccess="¿Dónde comprar?" aria-label="¿Dónde comprar?"/>}
              />
            </Tabs>
          </Box>
          </>

  );
}

export default TabsHeader;
